var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiHaiListIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#haidiHaiListIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 6.75H3.75v1.5H12v-1.5ZM2.25 6.75H0v1.5h2.25v-1.5ZM8.25 9.75h-4.5v1.5h4.5v-1.5ZM2.25 9.75H0v1.5h2.25v-1.5ZM9 3.75H3.75v1.5H9v-1.5ZM2.25 3.75H0v1.5h2.25v-1.5ZM12 .75H3.75v1.5H12V.75ZM2.25.75H0v1.5h2.25V.75Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "haidiHaiListIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h12v12H0z"
})))));
export default SvgHaidiHaiListIcon;